module.exports = __webpack_public_path__ + "static/media/blueHealthcare.6318b393.svg";